/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1ExamLangsId202,
  PutApiV1ExamLangsId401,
  PutApiV1ExamLangsId404,
  PutApiV1ExamLangsId500,
  PutApiV1ExamLangsIdMutationRequest,
  PutApiV1ExamLangsIdMutationResponse,
  PutApiV1ExamLangsIdPathParams,
} from "../../types/examEvaluationController/PutApiV1ExamLangsId.ts";
import { examLangUpdateViewModelSchema } from "../examLangUpdateViewModelSchema.ts";

export const putApiV1ExamLangsIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<PutApiV1ExamLangsIdPathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const putApiV1ExamLangsId202Schema =
  z.any() as unknown as ToZod<PutApiV1ExamLangsId202>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1ExamLangsId401Schema =
  z.any() as unknown as ToZod<PutApiV1ExamLangsId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const putApiV1ExamLangsId404Schema =
  z.any() as unknown as ToZod<PutApiV1ExamLangsId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1ExamLangsId500Schema =
  z.any() as unknown as ToZod<PutApiV1ExamLangsId500>;

export const putApiV1ExamLangsIdMutationRequestSchema = z.lazy(
  () => examLangUpdateViewModelSchema,
) as unknown as ToZod<PutApiV1ExamLangsIdMutationRequest>;

export const putApiV1ExamLangsIdMutationResponseSchema = z.lazy(
  () => putApiV1ExamLangsId202Schema,
) as unknown as ToZod<PutApiV1ExamLangsIdMutationResponse>;
